import * as types from './mutation_types';
import { EventBus } from '@/event-bus.js';

export default {

   [types.SET_INST_RECID](state, {instanceRecid, templateRecid, channelRecid, userRole}) {
      state.instanceRecid = instanceRecid;
      state.templateRecid = templateRecid;
      state.channelRecid = channelRecid;
      state.userRole = userRole;
   },

   [types.RESET_SMART_CANVAS](state) {
      state.instanceRecid = -1;
      state.instanceJson = {};
      state.instanceTitle = '';
      state.instanceStatus = 1;
      state.currScene = "scene1";
      state.editsMade = false;
      state.activeZoneType = -1;
      state.activeZoneId = -1;
      state.activeZone = {};
      state.currActiveAssetRecid = -1;
      state.zoneToAssetsDict = {};
      state.isGlobal = false;
      state.hiddenZones = [];
      state.moveImage = 0;
      state.mpOpen = false;
      state.overlay = false;
      state.displayColorPicker = false;
      state.moveImageZoneId = -1;
      state.locked = false;
      state.editingInstanceUser = '';
   },

   [types.REQUEST_INSTANCE_DATA](state) {
      state.isLoadingInstance = true;
   },

   [types.RECEIVE_INSTANCE_DATA_SUCCESS](state, data) {
      state.instanceTitle = data.title;
      state.instanceStatus = data.status;
      try {
         state.instanceJson = JSON.parse(data.json);
      } catch {
         console.log("error parsing JSON. JSON must be invalid");
      };
      
      state.allZones = state.instanceJson.tmpl.assets.concat(state.instanceJson.tmpl.data.text);
      state.channels = data.channels;
      state.templateRecid = data.parent_fk;
      if (data.channels.length > 1) {
         state.isGlobal = true;
      }
      if (state.instanceJson.tmpl.duration) {
         state.duration = state.instanceJson.tmpl.duration;
      }
         
      //add loading state to each zone
      for (let zone of state.instanceJson.tmpl.assets) {
         zone.isAssigningAsset = false;
         if (zone.thumbnail) {
            state.thumbnail = zone.val;
         }
      }

      state.isLoadingInstance = false;
   },

   [types.CHANGE_TITLE](state, title) {
      state.instanceTitle = title;
   },

   [types.CHANGE_SCENE](state, scene) {
      state.currScene = scene;
   },

   [types.SET_ACTIVE_ZONE](state, zone) {
      state.displayColorPicker = false;
      
      state.activeZoneId = zone.id;
      state.activeZoneType = zone.type;
      state.currActiveAssetRecid = zone.asset_recid;
      state.activeZone = zone;
   },

   //Zone mutations
   [types.CHANGE_ZONE_TEXT](state, {zoneId, text}) {
      let i = state.instanceJson.tmpl.data.text.findIndex((z) => {
         return z.id == zoneId;
      });
      let zone = state.instanceJson.tmpl.data.text[i];
      zone.val = text;
      state.instanceJson.tmpl.data.text.splice(i, 1, zone);
   },

   [types.CHANGE_ZONE_COLOR](state, color) {
      state.activeZone.style.backgroundColor = color.hex8;
   },

   [types.IS_ASSIGNING_ASSET](state) {
      // state.activeZone.isAssigningAsset = true;
   },
   
   [types.UPDATE_ZONE_ASSET_DICT](state, asset) {
      //if this zone already had an asset assigned to it
      //we need to keep track of that in our zones->asset dictionary
      if (state.currActiveAssetRecid) {

         //if we've already changed this zone in this "edit session", 
         //then we don't want to change the 'old' value
         if (!state.zoneToAssetsDict[state.activeZone.id]) {
            state.zoneToAssetsDict[state.activeZone.id] = {};
            state.zoneToAssetsDict[state.activeZone.id].old = state.currActiveAssetRecid;
         } else {
            if (!state.zoneToAssetsDict[state.activeZone.id]) {
               state.zoneToAssetsDict[state.activeZone.id] = {};
               state.zoneToAssetsDict[state.activeZone.id].old = '';
            }
         }
      } else {
         state.zoneToAssetsDict[state.activeZone.id] = {};
      }
      state.zoneToAssetsDict[state.activeZone.id].val_type = asset.c_asset_type;
      state.zoneToAssetsDict[state.activeZone.id].new = asset.recid;
   },

   [types.ASSIGN_ASSET](state, {asset, val, title, thumb}) {
      state.activeZone.asset_recid = asset.recid;
      state.activeZone.title = title;
      state.activeZone.val = val;
      state.activeZone.val_type = asset.c_asset_type;
      state.activeZone.thumb = thumb;
      if (state.activeZone.thumbnail) {
         state.thumbnail = asset.c_uri;
      }
      if (state.activeZone.duration) {
         state.duration = asset.c_duration;
      }
      state.currActiveAssetRecid = asset.recid;
      // state.activeZone.isAssigningAsset = false;
   },

   [types.REMOVE_ASSET](state, zone) {
      if (!state.zoneToAssetsDict[zone.id]) {
         state.zoneToAssetsDict[zone.id] = {};
         state.zoneToAssetsDict[zone.id].old = zone.asset_recid;
         state.zoneToAssetsDict[zone.id].new = '';
         state.zoneToAssetsDict[zone.id].val_type = zone.val_type;
      }
      zone.asset_recid = '';
      zone.val = '';
      zone.title = '';
      zone.thumb = '';
      if (zone.val_type) {
         zone.val_type = '';
      }
   },


   //Saving
   [types.REQUEST_SAVE_INSTANCE](state) {
      state.isSaving = true;
   },

   [types.RECEIVE_SAVE_INSTANCE_ERROR](state, {error, status}) {
      state.attemptedStatusSave = status;
      if (error == 'title') {
         state.duplicateTitleErrorState = true;
      }
      state.isSaving = false;
   },

   [types.RECEIVE_SAVE_INSTANCE_SUCCESS](state, data) {
      state.isSaving = false;
      state.editsMade = false;
      state.zoneToAssetsDict = {};
		// KML - 2020-03-06 - added in passthrough of instance status to allow
		//							 Save As to appear after initial Save
		state.instanceStatus = data.instanceStatus;
		// END KML
      EventBus.$emit('instance-saved');
   },

   //Saving As
   [types.REQUEST_SAVE_AS_INSTANCE](state) {
      state.isSavingAs = true;
   },

   [types.RECEIVE_SAVE_AS_INSTANCE_SUCCESS](state, data) {
      state.isSavingAs = false;
      state.saveAsState = false;
      state.editsMade = false;
      state.zoneToAssetsDict = {};
      EventBus.$emit('instance-saved', data);
   },

   [types.RECEIVE_SAVE_AS_INSTANCE_ERROR](state, {error}) {
      state.isSavingAs = false;
      if (error == 'title') {
         state.duplicateTitleErrorState = true;
      }
   },


   //Hide/Show Zones
   [types.TOGGLE_HIDE_ZONE](state, {hide, zoneId}) {
      if (hide) { //add zones to hidden zones
         state.hiddenZones.push(zoneId);
      } else { //remove zone from hidden zones
         var index = state.hiddenZones.indexOf(zoneId);
         if (index > -1) {
            state.hiddenZones.splice(index, 1);
         }

      }
   },

   [types.TOGGLE_ALL_ZONES](state) {
      state.hiddenZones = [];
   },

   [types.SCALE_IMAGE](state, direction) {
      if (direction === 'up') {
         if (state.activeZone.scaleX < 0) {
            state.activeZone.scaleX = (Math.abs(state.activeZone.scaleX) + 0.03) * -1;
         } else {
            state.activeZone.scaleX += 0.03;
         }

         if (state.activeZone.scaleY < 0) {
            state.activeZone.scaleY = (Math.abs(state.activeZone.scaleY) + 0.03) * -1;
         } else {
            state.activeZone.scaleY += 0.03;
         }
      } else {
         if (state.activeZone.scaleX < 0) {
            state.activeZone.scaleX = (Math.abs(state.activeZone.scaleX) - 0.03) * -1;
         } else {
            state.activeZone.scaleX -= 0.03;
         }

         if (state.activeZone.scaleY < 0) {
            state.activeZone.scaleY = (Math.abs(state.activeZone.scaleY) - 0.03) * -1;
         } else {
            state.activeZone.scaleY -= 0.03;
         }
      }
   },

   [types.ROTATE_IMAGE](state, direction) {
      if (direction === 'right') {
         state.activeZone.rotation += 45;
      } else {
         state.activeZone.rotation -= 45;
      }
   },

   [types.FLIP_IMAGE](state, direction) {
      if (direction === 'vertical') {
         state.activeZone.scaleX *= -1;
      } else {
         state.activeZone.scaleY *= -1;
      }
   },

   [types.TOGGLE_MOVE_IMAGE](state) {
      if (state.moveImageZoneId > 0) {
         state.moveImageZoneId = -1;
      } else {
         state.moveImageZoneId = state.activeZoneId;
      }
   },

   [types.TOGGLE_COLOR_PICKER](state) {
      state.displayColorPicker = !state.displayColorPicker;
   },

   [types.PREVIEW_INSTANCE](state) {
      state.preview = true;
   },

   [types.CLOSE_PREVIEW](state) {
      state.preview = false;
   },

   [types.SAVE_AS_STATE](state, saveAs) {
      state.saveAsState = saveAs;
   },

   [types.UNSAVED_NAVIGATION_STATE](state) {
      state.unsavedNavigationState = true;
   },

   [types.EDITS_MADE](state) {
      if (!state.editsMade) {
         EventBus.$emit('sc-edits-made');
         state.editsMade = true;
      }
   },

   [types.ADMIN_UNLOCK_MODAL](state,  {user, channelRecid, instanceRecid}) {
      state.isLoadingInstance = false;
      state.unlockInstanceModal = true;
      state.editingInstanceUser = user;
      state.attemptedOpenInstanceRecid = instanceRecid;
      state.attemptedOpenChannelRecid = channelRecid;
   },

   [types.CLOSE_UNLOCK_MODAL](state) {
      state.unlockInstanceModal = false;
   },


   [types.SET_ERROR_MESSAGE](state, errorMessage) {
      Object.assign(state, { errorMessage });
   },

   [types.CLOSE_MODAL](state) {
      state.errorMessage = null;
   },
   
   [types.INSTANCE_LOCKED](state, user) {
      state.locked = true;
      state.editingInstanceUser = user;
   },

   [types.INSTANCE_UNLOCKED](state) {
      state.locked = false;
      state.editingInstanceUser = '';
   },

   [types.UNIQUE_TITLE_ERROR](state) {
      state.uniqueTitleError = true;
   },

   [types.RESET_ERRORS](state) {
      state.uniqueTitleError = false;
   }
}
